export const teamsConstants = {
  GET_TEAMS: 'GET_TEAMS',
  ADD_TEAM: 'ADD_TEAM',
  DELETE_TEAM: 'DELETE_TEAM',
  CLEAR_TEAMS: 'CLEAR_TEAMS',
};
